import React from "react";
import logo from "../image/logo.jpg";
import { Link, useLocation } from "react-router-dom";
import Search from "../search/Search";
import "./Navbar.css";

export const Navbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  function logout() {
    localStorage.removeItem("user");
    window.location = "/admin";
  }

  const userRaw = localStorage.getItem("user");
  const isAdmin = userRaw && userRaw !== "null" && userRaw !== "";

  let userObj = {};
  if (isAdmin) {
    try {
      userObj = JSON.parse(userRaw);
    } catch (e) {
      console.error(e);
    }
  }

  // Helper to determine if a dropdown is active
  const isDropdownActive = (paths) => {
    return paths.includes(currentPath) ? "active-dropdown" : "";
  };

  return (
    <nav className={`navbar navbar-expand-lg premium-navbar fixed-top shadow-sm ${isAdmin ? 'admin-nav' : ''}`}>
      <div className="container-fluid">
        <Link className="navbar-brand ms-2" to="/">
          <img src={logo} width="180" height="50" alt="Logo" className="rounded" />
        </Link>

        <button
          className="navbar-toggler custom-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          {!isAdmin ? (
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 fw-semibold">
              <li className="nav-item mx-1 mx-xl-2">
                <Link className={`nav-link premium-link ${currentPath === "/" ? "active" : ""}`} to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item dropdown mx-1 mx-xl-2">
                <a className={`nav-link dropdown-toggle premium-link ${isDropdownActive(['/intrapeneurship', '/entrepreurship', '/internshipform'])}`} href="#!" id="studiosDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Studios
                </a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="studiosDropdown">
                  <Link className="dropdown-item" to="/intrapeneurship">Intrapreneurship Studio</Link>
                  <Link className="dropdown-item" to="/entrepreurship">Entrepreneurship Studio</Link>
                  <Link className="dropdown-item" to="/internshipform">Internship Studio</Link>
                </div>
              </li>

              <li className="nav-item dropdown mx-1 mx-xl-2">
                <a className={`nav-link dropdown-toggle premium-link ${isDropdownActive(['/innovation'])}`} href="#!" id="productsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Products and Solutions
                </a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="productsDropdown">
                  <Link className="dropdown-item" to="/innovation">Innovation</Link>
                  <a className="dropdown-item" href="https://projects.sltdigitallab.lk/login?ref=%2Fprojects" target="_blank" rel="noopener noreferrer">Management Console</a>
                  <a className="dropdown-item" href="https://devcloud.sltdigitallab.lk/site/login" target="_blank" rel="noopener noreferrer">Developer Cloud</a>
                </div>
              </li>

              <li className="nav-item dropdown mx-1 mx-xl-2">
                <a className={`nav-link dropdown-toggle premium-link ${isDropdownActive(['/university', '/industry', '/ongoing'])}`} href="#!" id="collabDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Collaboration and Programs
                </a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="collabDropdown">
                  <Link className="dropdown-item" to="/university">University Partnership</Link>
                  <Link className="dropdown-item" to="/industry">Industry Partnership</Link>
                  <Link className="dropdown-item" to="/ongoing">Ongoing Programs</Link>
                </div>
              </li>

              <li className="nav-item dropdown mx-1 mx-xl-2">
                <a className={`nav-link dropdown-toggle premium-link ${isDropdownActive(['/news', '/blogs'])}`} href="#!" id="newsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Latest News
                </a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="newsDropdown">
                  <Link className="dropdown-item" to="/news">News/Event</Link>
                  <Link className="dropdown-item" to="/blogs">Blogs</Link>
                </div>
              </li>

              <li className="nav-item dropdown mx-1 mx-xl-2">
                <a className={`nav-link dropdown-toggle premium-link ${isDropdownActive(['/contactus', '/team'])}`} href="#!" id="contactDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Contact US
                </a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="contactDropdown">
                  <Link className="dropdown-item" to="/contactus">Contact US</Link>
                  <Link className="dropdown-item" to="/team">Our Team</Link>
                </div>
              </li>
            </ul>
          ) : (
            <ul className="navbar-nav mr-auto ml-auto mb-2 mb-lg-0 fw-semibold mx-auto">
              <li className="nav-item mx-1"><Link className="nav-link premium-link" to="/user">Users</Link></li>
              <li className="nav-item dropdown mx-1">
                <a className="nav-link dropdown-toggle premium-link" href="#!" id="adminStudiosDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Studios</a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="adminStudiosDropdown">
                  <Link className="dropdown-item" to="/Aintraemail">Intrapreneurship Studio</Link>
                  <Link className="dropdown-item" to="/Aentraemail">Entrepreneurship Studio</Link>
                  <Link className="dropdown-item" to="/Ainternshipemail">Internship</Link>
                </div>
              </li>
              <li className="nav-item mx-1"><Link className="nav-link premium-link" to="/Ainnovation">Innovation</Link></li>
              <li className="nav-item dropdown mx-1">
                <a className="nav-link dropdown-toggle premium-link" href="#!" id="adminCollabDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Collab and Programs</a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="adminCollabDropdown">
                  <Link className="dropdown-item" to="/Auniversity">University Partnership</Link>
                  <Link className="dropdown-item" to="/Aindustry">Industry Partnership</Link>
                  <Link className="dropdown-item" to="/Aongoing">Ongoing Partnership</Link>
                </div>
              </li>
              <li className="nav-item dropdown mx-1">
                <a className="nav-link dropdown-toggle premium-link" href="#!" id="adminNewsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">News and Events</a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="adminNewsDropdown">
                  <Link className="dropdown-item" to="/Anews">News And Events</Link>
                  <Link className="dropdown-item" to="/Ablogsdisplay">Blogs</Link>
                </div>
              </li>
              <li className="nav-item dropdown mx-1">
                <a className="nav-link dropdown-toggle premium-link" href="#!" id="adminContactDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">ContactUS</a>
                <div className="dropdown-menu premium-dropdown shadow border-0 mt-2" aria-labelledby="adminContactDropdown">
                  <Link className="dropdown-item" to="/Acontactadmin">Contact US</Link>
                  <Link className="dropdown-item" to="/Ateam">Our Team</Link>
                </div>
              </li>
            </ul>
          )}

          <div className="d-flex align-items-center me-2">
            {!isAdmin ? (
              <Search />
            ) : (
              <div className="text-end text-dark">
                <div className="small fw-bold">Welcome, {userObj?.details?.name}</div>
                <div className="small text-muted mb-1" style={{ fontSize: "0.8rem" }}>{userObj?.details?.email}</div>
                <button className="btn btn-sm btn-outline-dark" onClick={logout}>
                  <i className="fa fa-sign-in me-1"></i> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
